import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { collection, onSnapshot, orderBy, query } from "firebase/firestore";
import { db } from "../../backend/firebase";
import Dataset from "../../components/Dataset";
import "./LikedScreen.css";

const LikedScreen = () => {
  const { uid } = useParams();
  const navigate = useNavigate();
  const [likedDatasets, setLikedDatasets] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Real-time listener for likes
    const q = collection(db, "Users", uid, "likes");
    const likeRef = query(q, orderBy("likedAt", "desc"));

    const unsubscribe = onSnapshot(likeRef, (snapshot) => {
      const data = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setLikedDatasets(data);
      setLoading(false);
    }, (error) => {
      console.error("Error fetching likes:", error);
      setLoading(false);
    });

    return () => unsubscribe();
  }, [uid]);

  const handleBack = () => {
    navigate(-1);
  };

  if (loading) {
    return (
      <div className="liked-screen">
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Loading liked datasets...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="liked-screen">
      {/* Header Section - Exact match to DownloadScreen style */}
      <div className="section-header-liked">
         <div className="section-header">
          <h2>Your Liked Datasets</h2>
        </div>
      </div>

      {/* Grid Section */}
      {likedDatasets.length === 0 ? (
        <div className="empty-datasets">
          <div className="empty-icon">❤️</div>
          <p>No liked datasets yet</p>
          <p className="empty-subtext">Datasets you like will appear here</p>
        </div>
      ) : (
        <div className="datasets-list">
          {likedDatasets.map((dataset, index) => (
            <Dataset
              key={dataset.id}
              datasetid={dataset.id}
              index={index}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default LikedScreen;